module.exports = __webpack_public_path__ + "media/promo/panasonic/images/knife-4f6a69bdd8af144ea4e8f9d462790328.png";